/** Monaco Diff Editor component for side-by-side and inline git diff viewing. */

import { useState } from "react";
import { DiffEditor } from "@monaco-editor/react";
import { useTheme } from "../hooks/ThemeContext";

interface Props {
  path: string;
  original: string;
  modified: string;
  onClose: () => void;
}

export function MonacoDiffViewer({
  path,
  original,
  modified,
  onClose,
}: Props): JSX.Element {
  const { theme } = useTheme();
  const [inline, setInline] = useState(false);

  return (
    <div className="editor-pane" style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
      <div className="editor-tabs" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 8px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span className="tab active" style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}>
            <span>Diff: {path}</span>
            <span style={{ fontSize: 11, opacity: 0.7 }}>(HEAD ↔ Working Tree)</span>
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <button
            onClick={() => setInline((v) => !v)}
            title="Toggle side-by-side or inline diff"
            style={{ fontSize: 11, padding: "2px 8px" }}
          >
            {inline ? "Side-by-Side View" : "Inline View"}
          </button>
          <button
            onClick={onClose}
            title="Close diff and return to editor"
            style={{ fontSize: 11, padding: "2px 8px" }}
          >
            ✕ Close Diff
          </button>
        </div>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <DiffEditor
          original={original}
          modified={modified}
          language="latex"
          theme={theme === "dark" ? "vs-dark" : "light"}
          options={{
            readOnly: true,
            renderSideBySide: !inline,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            fontSize: 13,
            lineNumbers: "on",
            wordWrap: "on",
            automaticLayout: true,
          }}
        />
      </div>
    </div>
  );
}
